import React, { useEffect, useState } from 'react';

interface StatusToggleProps {
  options: string[];
  value: string;
  onChange: (newValue: string) => void;
}

export const StatusToggle: React.FC<StatusToggleProps> = ({
  options,
  value,
  onChange,
}) => {
  const [selected, setSelected] = useState(value);

  useEffect(() => {
    setSelected(value); // Sync with prop change
  }, [value]);

  const handleToggle = (option: string) => {
    setSelected(option);
    onChange(option);
  };

  return (
    <div className='flex rounded-full p-0.5 w-auto bg-primary-background overflow-hidden max-w-[260px]'>
      { options.map((option) => (
        <button
            key={option}
            className={`px-3 w-full py-1 text-xs transition-all font-medium duration-300 ease-in-out rounded-full ${
              selected === option
                ? 'bg-white text-primary-dark shadow-md'
                : 'text-primary-text'
            } hover:bg-primary-dark hover:text-white`}
            onClick={() => handleToggle(option)}
        >
          { option }
        </button>
      )) }
    </div>
  );
};
